import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ovulation-induction',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ovulation-induction.component.html',
  styleUrl: './ovulation-induction.component.scss'
})
export class OvulationInductionComponent implements OnInit {

  constructor(private route: Router, private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {

    const ovulationSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/ovulation-induction",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(ovulationSchema);
    this.renderer.appendChild(this.document.head, script);




    this.titleService.setTitle('Ovulation Induction Treatment in Kannur | NCare IVF Centre');
    this.metaService.updateTag({
      name: 'description',
      content: 'Ovulation Induction at NCARE IVF Centre in Kannur, a trusted treatment to enhance fertility and support your journey to parenthood.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Ovulation induction treatment, Ovulation Induction, ovulation induction treatment near me'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Ovulation Induction Treatment in Kannur | NCare IVF Centre'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Ovulation Induction at NCARE IVF Centre in Kannur, a trusted treatment to enhance fertility and support your journey to parenthood.'
    });

  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}
